import api from "../../../../services/api";
import { normalizarGiro, rotarImagen } from "./rotarDocumento";

/**
 * Rotación persistente de documentos del modelo ANTIGUO (backend /documentos,
 * DocumentoPersonaStorage), los que se ven por el visor externo (iframe).
 *
 *   GET  documentos/rotar?userId&personaDNI&documentoId          -> binario
 *   POST documentos/rotar?userId&personaDNI&documentoId&grados   -> guarda
 *
 * Como el listado no trae la extensión, primero se baja el binario: si es PDF el
 * backend lo rota (pdf-lib); si es imagen se rota aquí con canvas y se envía.
 */

const mensajeDeError = async (error: any, fallback: string): Promise<string> => {
  const data = error?.response?.data;
  try {
    const payload = data instanceof Blob ? JSON.parse(await data.text()) : data;
    const message = payload?.message;
    if (typeof message === "string" && message.trim()) return message;
  } catch {
    // Respuesta sin JSON: se usa el mensaje por defecto.
  }
  if (!error?.response) return "No se pudo conectar con el servidor. Revisa tu conexión e intenta nuevamente.";
  return fallback;
};

export const rotarDocumentoLegacy = async ({
  personaDNI,
  documentoId,
  giro,
}: {
  personaDNI: string;
  documentoId: string;
  giro: number;
}): Promise<void> => {
  const grados = normalizarGiro(giro);
  if (grados === 0) throw new Error("El documento no tiene rotación pendiente.");
  const userId = sessionStorage.getItem("usuarioId") ?? "";
  const params = { userId, personaDNI, documentoId };

  try {
    const original = await api.get<Blob>("documentos/rotar", { params, responseType: "blob" });
    const mimeType = String(original.headers?.["content-type"] || original.data?.type || "").split(";")[0].trim();

    if (mimeType === "application/pdf") {
      await api.post("documentos/rotar", null, { params: { ...params, grados } });
      return;
    }
    if (mimeType !== "image/jpeg" && mimeType !== "image/png") {
      throw new Error("Solo se pueden rotar imágenes JPG/PNG o documentos PDF.");
    }

    const rotada = await rotarImagen(original.data, grados, mimeType);
    const fd = new FormData();
    fd.append("files", new File([rotada], `documento.${mimeType === "image/png" ? "png" : "jpg"}`, { type: mimeType }));
    await api.post("documentos/rotar", fd, { params: { ...params, grados } });
  } catch (error) {
    if (error instanceof Error && !(error as any).isAxiosError) throw error;
    throw new Error(await mensajeDeError(error, "No se pudo guardar la rotación del documento."));
  }
};
